import { render, staticRenderFns } from "./SanteActifs.vue?vue&type=template&id=38bcdfae&scoped=true&"
import script from "./SanteActifs.vue?vue&type=script&lang=js&"
export * from "./SanteActifs.vue?vue&type=script&lang=js&"
import style0 from "./SanteActifs.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SanteActifs.vue?vue&type=style&index=1&id=38bcdfae&lang=scss&scoped=true&"
import style2 from "./SanteActifs.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bcdfae",
  null
  
)

export default component.exports